<template>
  <div>
    <settings-card :config="config">
      <el-button
        type="text"
        @click="settings">去设置</el-button>
    </settings-card>
    <warehouse-modal ref="warehouse" />
  </div>
</template>
<script>
import { mapState } from 'vuex'
import SettingsCard from '../settings-card.vue'
import WarehouseModal from './warehouse-modal.vue'
export default {
  name: 'WarehouseCard',
  components: { SettingsCard, WarehouseModal },
  props: {
    config: {
      type: Object,
      default() { return {} }
    }
  },
  computed: {
    ...mapState({
      userInfo: state => state.account.userInfo
    })
  },
  methods: {
    settings() {
      // this.$refs.warehouse.fetch()
      this.$router.push({ path: '/appraisal-ai-warehouse' })
    }
  }
}
</script>
